module.exports = "/images/vendor/desiigner-svg/svg/places/cutlery.svg?82f2a07bec32566df7843768bc832c37";